import React from "react";
import { useDispatch, useSelector } from "react-redux";
import classnames from "classnames";
import ReactHtmlParser from "react-html-parser";

import styles from "./phoneme.module.css";
import { State } from "../../redux/store";
import * as phonemeActions from "../../redux/actions/phoneme";
import {
  BALLOON_STAGE,
  BASKET_STAGE,
  CLOUD_STAGE,
} from "../../redux/reducers/stateIdentifiers";
import { srcPath } from "../../util/Path";
import { defaultWidth } from "../../util/Constants";

const instructionTitle = (stage: string, mainPhonics: string): string => {
  const img = `
  <img
    class="instruction-icon"
    src="${srcPath(`phoneme/game_icons/icon_${mainPhonics}.png`)}"
    alt=""
  />
  `;

  switch (stage) {
    case BALLOON_STAGE:
      return `Pop the balloons with the${img}sound.`;
    case BASKET_STAGE:
      return `Drag the${img}words into the basket.`;
    case CLOUD_STAGE:
      return `Listen and find the${img}sound.`;
    default:
      return null;
  }
};

interface Props {
  itemLeft: number;
}

const Instruction = (props: Props) => {
  const dispatch = useDispatch();

  const { itemLeft } = props;

  const { stage, mainPhonics } = useSelector((state: State) => state.phoneme);
  const title = instructionTitle(stage, mainPhonics);

  const closeInstruction = () => {
    if (stage === BALLOON_STAGE) {
      setTimeout(() => dispatch(phonemeActions.readyBalloon()), 500);
    }
    dispatch(phonemeActions.closeInstruction());
  };

  return (
    <div
      className={styles.instruction}
      style={{
        width: `${defaultWidth - itemLeft * 2}px`,
        left: `${itemLeft}px`,
      }}
    >
      {title && (
        <div className={styles.instructionBoard}>
          <div className={styles.instructionTitle}>
            {ReactHtmlParser(title)}
          </div>
          <img
            className={classnames("btn", "main-btn", styles.instructionBtn)}
            src={srcPath("shared/next.png")}
            alt=""
            onClick={closeInstruction}
          />
        </div>
      )}
    </div>
  );
};

export default Instruction;
